import { VAvatar } from 'vuetify/lib/components/VAvatar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VAvatar,{staticClass:"d-flex mx-auto justify-space-around",attrs:{"color":_vm.logo !== null ? 'white' : 'transparent',"size":_vm.size}},[(_vm.logo !== null)?_c('img',{attrs:{"src":_vm.logo,"loading":"lazy","alt":_vm.content}}):_c('span',{staticClass:"display-1"},[_vm._v(" "+_vm._s(_vm._f("uppercase")(_vm.initials))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }